import api from 'config/axios';
import AppService from 'common/app-service';
import { CteStatus, EDfeOrigin, EDfeType, ICTe } from 'common/cte.interface';
import { ICteCountInfo, ICTeMonitorInfo } from 'common/cte-monitoring.interface';
import downloadRedirect from 'download-redirect';

export default class CtesService extends AppService {
  constructor() {
    super('dfes', api);
  }

  async allAvailable(params?: {
    takerRootId?: string | undefined;
    cteEmissionDateMin?: string | undefined;
    cteEmissionDateMax?: string | undefined;
    cteUploadDateMin?: string | undefined;
    cteUploadDateMax?: string | undefined;
    ndfe?: string | undefined;
    dfeType?: EDfeType | undefined;
    origin?: EDfeOrigin | undefined;
    hasDueDate?: boolean | undefined;
  }): Promise<ICTe[]> {
    const queryParams = {
      taker_root_id: params?.takerRootId,
      issue_date_start: params?.cteEmissionDateMin,
      issue_date_end: params?.cteEmissionDateMax,
      created_at_start: params?.cteUploadDateMin,
      created_at_end: params?.cteUploadDateMax,
      ndfe: params?.ndfe,
      dfe_type: params?.dfeType,
      origin: params?.origin,
      has_due_date: params?.hasDueDate,
    };

    const response = await this.api.get(this.root('available'), { params: queryParams });
    return response.data;
  }

  async all(params?: {
    takerRootId?: string | undefined;
    cteEmissionDateMin?: string | undefined;
    cteEmissionDateMax?: string | undefined;
    cteUploadDateMin?: string | undefined;
    cteUploadDateMax?: string | undefined;
    ndfe?: string | undefined;
    dfeType?: EDfeType | undefined;
  }): Promise<ICTe[]> {
    const queryParams = {
      taker_root_id: params?.takerRootId,
      issue_date_start: params?.cteEmissionDateMin,
      issue_date_end: params?.cteEmissionDateMax,
      created_at_start: params?.cteUploadDateMin,
      created_at_end: params?.cteUploadDateMax,
      ndfe: params?.ndfe,
      dfe_type: params?.dfeType,
    };

    const response = await this.api.get(this.root('all'), { params: queryParams });
    return response.data;
  }

  async monitoring(): Promise<ICTeMonitorInfo[]> {
    const response = await this.api.get(this.root('monitoring'));
    return response.data;
  }

  async getXmlDownloadLink(originFileKey: string): Promise<void> {
    const response = await this.api.get(this.root('download'), { params: { originFileKey } });
    downloadRedirect(response.data.url, response.data.filename);
  }

  async deleteCtes(ctesIds: Array<ICTe['id']>) {
    await this.api.patch(this.root('status'), { ids: ctesIds, status: CteStatus.DISABLED });
  }

  async getAvailableCount(params?: { origin?: EDfeOrigin; hasDueDate?: boolean; dfeType?: EDfeType }): Promise<ICteCountInfo> {
    const response = await this.api.get(this.root('available/count'), {
      params: {
        origin: params?.origin,
        has_due_date: params?.hasDueDate,
        dfe_type: params?.dfeType,
      },
    });
    return response.data;
  }
}
